import HotelCard from "./HotelCard";

import { useTranslation } from 'react-i18next';

const HotelList = ({ propiedades, ruta, lang, destino, config, adultos, ninos, llegada, salida, moneda, otraspropiedades, nuevosadultos }) => {

    const { t } = useTranslation();

    return (
        <>
            <div className="col-md-9">


                <div className="my-3 o-list-tags mt-md-1">
                    {destino ?
                        <li >
                            {destino} <button type="button" className="btn btn-close"></button>
                        </li>
                        :
                        ""
                    }

                </div>
                {
                    propiedades.length > 0 ?
                        propiedades.map((propi, index) => (
                            <HotelCard
                                key={propi.id || `hotel-${index}`}
                                hotel={propi}
                                ruta={ruta}
                                lang={lang}
                                config={config}
                                adultos={nuevosadultos}
                                ninos={ninos}
                                llegada={llegada}
                                salida={salida}
                                moneda={moneda}
                            />
                        ))
                        :
                        <>

                            <div className="centra" style={{ width: "100%" }}>
                                {t("No hay disponibilidad para su búsqueda. Le invitamos a modificar las fechas, el número de huéspedes o la duración de la estancia.")}
                            </div>
                            {config.textonodispo && (
                                <>
                                    <br />
                                    {config.textonodispo}
                                </>
                            )}
                            {
                                otraspropiedades.length > 0 && (
                                    <>
                                        <div className="centra" style={{ width: "100%" }}>
                                            {t("Otras opciones con capacidad menor a la buscada")}
                                        </div>
                                        {
                                            otraspropiedades.map((propi, index) => (
                                                <HotelCard
                                                    key={propi.id || `hotel-${index}`}
                                                    hotel={propi}
                                                    ruta={ruta}
                                                    lang={lang}
                                                    config={config}
                                                    adultos={adultos}
                                                    ninos={ninos}
                                                    llegada={llegada}
                                                    salida={salida}
                                                    moneda={moneda}
                                                />
                                            ))
                                        }
                                    </>
                                )
                            }
                        </>
                }

            </div >
            {/* <pagination-controls >
                <pagination-template>
                    <nav role="navigation" aria-label="Pagination">
                        <ul className="ngx-pagination">
                            <li className="pagination-previous disabled">
                                <span aria-disabled="true">
                                    Previous <span e="show-for-sr">page</span>
                                </span>
                            </li>
                            <li className="small-screen"> 1 / 1 </li>
                            <li className="current">
                                <span aria-live="polite">
                                    <span className="show-for-sr">You're on page </span>
                                    <span>1</span>
                                </span >
                            </li >
                            <li className="pagination-next disabled" >
                                <span aria-disabled="true">
                                    Next <span className="show-for-sr">page</span>
                                </span >
                            </li >
                        </ul >
                    </nav >
                </pagination-template>
            </pagination-controls >*/}
        </>
    )
};

export default HotelList;
